import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import TwField, { TwInputTypes } from "../TwFields/TwFields";

type Props = {
  cmValue: string | null;
  onChange: (value: string) => void;
  type?: "length" | "width" | "height";
  externalError?: string;
  label?: string;
};

const TwMetricSystemInput: React.FC<Props> = ({ 
    cmValue, 
    onChange,
    type,
    externalError,
    label
}) => {

  const [error, setError] = useState<string | null>(null);

  const handleCmChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value;

    // Allow only numbers and optional decimal point
    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    onChange(value);
  };

  useEffect(() => {
    if (externalError) {
      setError(externalError);
    }
  }, [externalError]);

  return (
    <TwField
      placeholder=""
      name={type ?? ''}
      label={label ?? ''}
      value={cmValue || ''}
      onInputChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        handleCmChange(e as React.ChangeEvent<HTMLInputElement>);
      }}
      inputType={TwInputTypes.text}
      error={error !== null}
      helperText={error || undefined}
      endAdorment={
        <Typography color="#9CA3AF" sx={{ fontSize: '14px' }}>
          cm
        </Typography>
      }
    />
  );
};

export default TwMetricSystemInput;
